import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Compoments
import CalendarHeader from './calendar-header';
import CalendarDay from './calendar-day';
import CalendarRow from './calendar-row';
import { Row, Column, Icon } from '@pella/sash-framework';

import { MONTHS } from '../../../../utilities/constants';

function PrevArrow(props) {
	// eslint-disable-next-line react/prop-types -- fix this
	const { onClick, disabled } = props;
	return (
		<button
			type='button'
			className={`${styles.slickArrows}${disabled ? ' ' + styles.slickArrow_Disabled : ''}`}
			disabled={disabled ? true : false}
			onClick={onClick}
			aria-label='Previous Month'
		>
			<Icon name='keyboard_arrow_left' />
		</button>
	);
}

function NextArrow(props) {
	// eslint-disable-next-line react/prop-types -- fix this
	const { onClick, disabled } = props;
	return (
		<button
			type='button'
			className={`${styles.slickArrows}${disabled ? ' ' + styles.slickArrow_Disabled : ''}`}
			disabled={disabled ? true : false}
			onClick={onClick}
			aria-label='Next Month'
		>
			<Icon name='keyboard_arrow_right' />
		</button>
	);
}

// Styles
import styles from './index.module.scss';
import { setLocalStorage } from '../../../../utilities/functions';

const RTACalendar = ({ timeslots, handleSelect, selectedDay, disabled }) => {
	const [month, setMonth] = useState(new Date().getMonth());
	const [year, setYear] = useState(new Date().getFullYear());
	const [timeslotObject, setTimeslotObject] = useState({});

	useEffect(() => {
		setTimeslotObject(showCalendar(month, year, timeslots));
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, [timeslots]);

	const showCalendar = (month, year, timeslots, depth = 0) => {
		if (depth > 4) {
			// Limit to 4 months worth of calendar rendering
			return { Calendar: [], CurrentMonth: MONTHS[month], CurrentYear: year };
		}

		setLocalStorage('showCalendar', [month, year, timeslots.length]);
		const firstDay = new Date(year, month).getDay();
		const daysInMonth = 32 - new Date(year, month, 32).getDate();
		let hasPreviousMonth = false;
		let hasNextMonth = false;
		let monthObject = {};
		let dateRows = [];
		// Specific cases may have a different number or rows
		let MAX_ROWS = 5;
		let currentDay = 1;
		let tp = 0;
		if (month === 1 && firstDay === 0 && daysInMonth < 29) {
			// Case that February only has 4 rows
			MAX_ROWS = 4;
		} else if ((firstDay > 4 && daysInMonth === 31) || (firstDay === 6 && daysInMonth === 30)) {
			// Case of month with 31 days with first day of month on Friday or Saturday OR a month that has 30 days with the first day on Saturday
			MAX_ROWS = 6;
		}
		// timeslots = [{ RESOURCE_ID: '10000000(0),10000001(0)', START_DATE: 'YEAR-MM-DDT00:00:00.000Z', END_DATE: 'YEAR-MM-DDT00:00:00.000Z' }, ...]
		const firstTimeslotMonth = parseInt(timeslots[0].START_DATE.split('T')[0].split('-')[1]) - 1;
		const lastTimeslotMonth = parseInt(timeslots[timeslots.length - 1].START_DATE.split('T')[0].split('-')[1]) - 1;
		if (firstTimeslotMonth < month || (firstTimeslotMonth === 11 && month === 0) || (firstTimeslotMonth >= 8 && month < 4)) {
			hasPreviousMonth = true;
		}
		if (lastTimeslotMonth > month || (lastTimeslotMonth === 0 && month === 11) || (lastTimeslotMonth < month && month >= 8)) {
			hasNextMonth = true;
		}
		for (let i = 0; i < MAX_ROWS; i++) {
			let weekObject = {};
			let newRow = [];
			let hasPreviousWeek = true;
			let hasNextWeek = false;
			for (let j = 0; j < 7; j++) {
				// Days of the week
				const dateDataObject = { Empty: true };
				if ((i === 0 && j < firstDay) || currentDay > daysInMonth) {
					newRow.push(dateDataObject);
				} else {
					dateDataObject.Empty = false;
					dateDataObject.innerText = currentDay;
					let hasTimeslots = false;
					let timeslotLength = 0;
					let arrayStartPosition = -1;
					for (let k = tp; k < timeslots.length; k++) {
						const day = timeslots[k].START_DATE.split('T')[0].split('-')[2];
						const timeslotMonth = timeslots[k].START_DATE.split('T')[0].split('-')[1];
						const timeslotYear = timeslots[k].START_DATE.split('T')[0].split('-')[0];
						if (parseInt(day) === currentDay && month === parseInt(timeslotMonth) - 1 && year === parseInt(timeslotYear)) {
							hasTimeslots = true;
							tp = k;
							timeslotLength++;
							if (arrayStartPosition === -1) {
								arrayStartPosition = tp;
								if (arrayStartPosition === 0) {
									hasPreviousWeek = false;
								}
							}
						}
					}
					if (tp === 0) {
						hasPreviousWeek = false;
					}
					if (arrayStartPosition !== -1 && j === 6) {
						if (arrayStartPosition + timeslotLength < timeslots.length - 1) {
							hasNextWeek = true;
						}
					}
					dateDataObject.arrayStartPosition = arrayStartPosition;
					dateDataObject.timeslotLength = timeslotLength;
					dateDataObject.hasTimeslots = hasTimeslots;
					newRow.push(dateDataObject);
					currentDay++;
				}
			}
			weekObject.hasPreviousWeek = hasPreviousWeek;
			weekObject.hasNextWeek = hasNextWeek;
			weekObject.week = newRow;
			dateRows.push(weekObject);
		}
		monthObject.Calendar = dateRows;
		monthObject.CurrentMonth = MONTHS[month];
		monthObject.CurrentYear = year;
		monthObject.hasNextMonth = hasNextMonth;
		monthObject.hasPreviousMonth = hasPreviousMonth;
		for (let i = 0; i < monthObject.Calendar.length; i++) {
			for (let j = 0; j < monthObject.Calendar[i].week.length; j++) {
				if (!monthObject.Calendar[i].week[j].Empty && monthObject.Calendar[i].week[j].timeslotLength > 0) {
					return monthObject;
				}
			}
		}

		if (month === 11) {
			return showCalendar(0, year + 1, timeslots, depth + 1);
		} else {
			return showCalendar(month + 1, year, timeslots, depth + 1);
		}
	};

	const jumpToNextMonth = (currentMonth, currentYear) => {
		const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;
		const nextMonth = (currentMonth + 1) % 12;
		setMonth(nextMonth);
		setYear(nextYear);
		setTimeslotObject(showCalendar(nextMonth, nextYear, timeslots));
		selectDay(0, null, null);
	};

	const jumpToPreviousMonth = (currentMonth, currentYear) => {
		const previousYear = currentMonth === 0 ? currentYear - 1 : currentYear;
		const previousMonth = currentMonth === 0 ? 11 : currentMonth - 1;
		setMonth(previousMonth);
		setYear(previousYear);
		setTimeslotObject(showCalendar(previousMonth, previousYear, timeslots));
		selectDay(0, null, null);
	};

	const selectDay = (id, arrayStartPosition, timeslotLength) => {
		handleSelect(arrayStartPosition, timeslotLength, id);
	};

	// const jumpToMonth = (month, year, timeslots) => {
	// 	showCalendar(month, year, timeslots);
	// }

	return (
		<div>
			{timeslots && (
				<React.Fragment>
					<Row>
						<Column
							sm='12'
							md='12'
						>
							<div className={styles.rtaCalendar_Month_Yeat_Label}>
								<PrevArrow
									disabled={disabled || !timeslotObject.hasPreviousMonth}
									onClick={() => {
										jumpToPreviousMonth(month, year);
									}}
								/>
								{timeslotObject.CurrentMonth} {timeslotObject.CurrentYear}
								<NextArrow
									disabled={disabled || !timeslotObject.hasNextMonth}
									onClick={() => {
										jumpToNextMonth(month, year);
									}}
								/>
							</div>
						</Column>
					</Row>
					<CalendarHeader />
					{timeslotObject.Calendar &&
						timeslotObject.Calendar.map((Calendar, index) => (
							<CalendarRow key={`row${index}`}>
								{Calendar.week.map((week, index2) => (
									<CalendarDay
										id={week.innerText}
										key={`row${index}day${index2}`}
										selected={selectedDay === week.innerText ? true : false}
										onClick={selectDay}
										innerText={week.innerText}
										empty={week.Empty}
										hasTimeslots={week.hasTimeslots}
										arrayStartPosition={week.arrayStartPosition}
										timeslotLength={week.timeslotLength}
										disabled={disabled}
									/>
								))}
							</CalendarRow>
						))}
					<hr />
				</React.Fragment>
			)}
		</div>
	);
};

RTACalendar.propTypes = {
	timeslots: PropTypes.array.isRequired,
	handleSelect: PropTypes.func.isRequired,
	selectedDay: PropTypes.number,
	disabled: PropTypes.bool,
};

export default RTACalendar;
